import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleFormat',
  standalone: true,
})
export class TitleFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    return value
      .split('-') // Split by hyphens
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(' '); // Join with spaces
  }
}
